export const featureDataWaterproofingSystems = {
    mainTitle: 'Why Choose HRD for Waterproofing?',
    items: [
        {
            number: '01',
            heading: 'Industry-Leading Waterproofing Solutions – We use premium materials and advanced application techniques.'
        },
        {
            number: '02',
            heading: 'Long-Term Protection – Ensuring lasting defense against moisture, leaks, and environmental damage.'
        },
        {
            number: '03',
            heading: 'Minimal Disruption – Strategic planning to reduce downtime and tenant inconvenience.'
        },
        {
            number: '04',
            heading: 'Comprehensive Surface Preparation – Power washing, priming, and repairing surfaces for optimal adhesion and performance.'
        },
        {
            number: '05',
            heading: 'Safety & Compliance – Meeting WorkSafeBC standards and all local building codes.'
        }
    ],
    title: "Seal & Protect Your Property Today!",
    subtitle:
        'From high-rise buildings and commercial properties to parkades and industrial structures, HRD provides expert waterproofing solutions to keep your building dry, secure, and structurally sound.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/12WaterproofingSystems/featuregridSection/fondo.png'
};
